export enum DenialPeriodType {
  Day = 'LAST_DAY',
  Week = 'LAST_WEEK',
}
